import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import type { AdItem } from '@sbt-web/network/types';
import { buildImageObjSchema } from './utils';
type Props = {
  adItems: AdItem[];
};
export const ImgObjSchemaListing: FC<Props> = t0 => {
  const $ = _c(2);
  const {
    adItems
  } = t0;
  let t1;
  if ($[0] !== adItems) {
    const imgSchemaObjs = adItems.map(_temp).filter(_temp2);
    t1 = imgSchemaObjs.length > 0 ? <script key="listing-image-object" {...jsonLdScriptProps({
      "@context": "https://schema.org",
      "@graph": imgSchemaObjs
    })} /> : null;
    $[0] = adItems;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(ad) {
  const firstImage = ad.images?.[0];
  if (!firstImage) {
    return null;
  }
  return buildImageObjSchema({
    ad,
    image: `${firstImage.cdnBaseUrl}?rule=gallery-desktop-2x-auto`,
    isRepresentative: false
  });
}
function _temp2(imgObj) {
  return imgObj !== null;
}